import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES, SEARCH_GROUPS } from '@constants/Text'

export default [
  {
    path: '/cobrancas',
    name: 'billing-system',
    redirect: '/cobrancas/geral',
    meta: {
      can_show: FEATURES.COBRANCAS_CVM,
      search: {
        title: 'Cobranças',
        description: 'Gestão de cobranças CVM do escritório',
        keywords: ['cobranças', 'cvm', 'faturas', 'boletos', 'financeiro'],
        icon: 'mdi-currency-usd',
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import(
          '@src/modules/billing-system/views/view-billing-system-nav-bar/view-billing-system-nav-bar.vue'
        )
      ),
    children: [
      {
        path: 'geral',
        name: 'billing-system.overview',
        meta: {
          can_show: FEATURES.COBRANCAS_CVM,
          search: {
            title: 'Cobranças — Visão Geral',
            description: 'Visão geral das cobranças CVM',
            keywords: ['cobranças', 'visão geral', 'cvm', 'resumo'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@src/modules/billing-system/views/view-billing-system-overview/view-billing-system-overview.vue'
            )
          ),
      },
    ],
  },
]
